// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ef1f0790","239":"d2dacd07","455":"ec99d07f"}[chunkId] + ".chunk.js";
};